import React from 'react'
import WrapperReactPage from '../General/WrapperReactPage'
import Overview from '../Overview'
import OverviewHero from './OverviewHero'
import TrailerPopupWrapper from '../Trailer/TrailerPopupWrapper'

const PageOverviewWrapper = ({ 
    theme, 
    features, 
    translation, 
    movies, 
    routesData,
    weischerAds, 
    headerAppearance,
    contentWidth,
    advertisements,
    elbenwald,
    programOverviewListStyle,
    siteHeaderData, 
    programOverviewStartviewType, 
    programOverviewShowtimesType,
    hasShowtimesFeature, 
    hasGridTrailerFeature,
    hasGridHoverTrailer,
    location,
    detailsStyling,
    posterStyling,
    attributeStyling,
    overviewSubtitle,
    match,
    informationStyling,
    stripeAppearance,
    overviewHeroItems,
    overviewHeroAdvertisementItems,
    isConnectedFast,
    hiddenAttributes,
    ignoreAttributesForPerformanceFilter,
    hasChatbot,
    isScrolledClass
}) => (
    <WrapperReactPage hasChatbot={hasChatbot} advertisements={advertisements} features={features} contentWidth={contentWidth} headerAppearance={headerAppearance} isScrolledClass={isScrolledClass} movies={movies} translation={translation}> 
        <OverviewHero
            overviewHeroItems={overviewHeroItems}
            overviewHeroAdvertisementItems={overviewHeroAdvertisementItems}
            features={features}
            movies={movies}
        />
        {movies && movies.items && <Overview 
            movies={movies.items}
            routesData={routesData}
            stripeAppearance={stripeAppearance}
            ignoreAttributesForPerformanceFilter={ignoreAttributesForPerformanceFilter}
            weischerAds={weischerAds}
            advertisements={advertisements}
            elbenwald={elbenwald}
            overviewSubtitle={overviewSubtitle}
            hiddenAttributes={hiddenAttributes}
            detailsStyling={detailsStyling}
            programOverviewListStyle={programOverviewListStyle}
            theme={theme}
            posterStyling={posterStyling}
            informationStyling={informationStyling}
            attributeStyling={attributeStyling}
            translation={translation}
            moviesOrder={movies.order}
            location={location}
            match={match}
            siteHeaderData={siteHeaderData}
            programOverviewShowtimesType={programOverviewShowtimesType}
            programOverviewStartviewType={programOverviewStartviewType}
            features={features}
            hasShowtimesFeature={hasShowtimesFeature}
            hasGridHoverTrailer={hasGridHoverTrailer}
            hasGridTrailerFeature={hasGridTrailerFeature}
            isConnectedFast={isConnectedFast}
        />}
        <TrailerPopupWrapper/>
    </WrapperReactPage>
)


export default PageOverviewWrapper